// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterThankYouModal_root__oStuY","rotation":"NewsletterThankYouModal_rotation__gf1Bz","preventivoBoxBubble":"NewsletterThankYouModal_preventivoBoxBubble__GR7gm"};